<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <div slot="header" />
      <ul class="nav">
        <template v-for="(item, idx) in navItems">
          <li
            v-if="isShow(item)"
            :key="idx"
            class="nav-item"
          >
            <template v-if="item.children">
              <app-sidebar-nav-dropdown
                :title="item.title"
                :name="item.name"
                :icon="item.icon"
              >
                <template
                  v-for="(child, idx2) in item.children"
                >
                  <li
                    :key="idx2"
                    class="nav-item"
                  >
                    <app-sidebar-nav-link
                      :title="child.title"
                      :name="child.name"
                      :icon="child.icon"
                      :badge="child.badge"
                    />
                  </li>
                </template>
              </app-sidebar-nav-dropdown>
            </template>
            <template v-else>
              <app-sidebar-nav-link
                :title="item.title"
                :name="item.name"
                :icon="item.icon"
                :badge="item.badge"
              />
            </template>
          </li>
        </template>
      </ul>
      <slot />
      <div slot="footer" />
    </nav>
  </div>
</template>
<script>
import AppSidebarNavDropdown from './SidebarNavDropdown.vue';
import AppSidebarNavLink from './SidebarNavLink.vue';

export default {
  name: 'AppSidebar',
  components: {
    AppSidebarNavDropdown,
    AppSidebarNavLink,
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    isShow(item) {
      if (item.only === undefined) {
        return true;
      }

      if (this.user().hasRole(item.only)) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
  .nav-link {
    cursor:pointer;
  }
</style>
